import { ApiError } from '../../../core/models/api-error.model';
import { PASSWORD_PARTS } from '../../../shared/utils/password-policy';

export { WORK_EMAIL_PATTERN } from '../../../shared/utils/work-email';

export interface ForgotPasswordRequest {
  email: string;
}

/** The emailed link carries only `email`; it goes back to the API. */
export interface ResetPasswordRequest {
  email: string;
  password: string;
  passwordConfirmation: string;
}

/** Error shown inline on the auth pages: the API's own message when it sends one, else `key`. */
export interface AuthNotice {
  key: string;
  text?: string;
}

export function noticeFrom(error: ApiError, key = error.messageKey): AuthNotice {
  return { key, text: error.message };
}

/** Error codes the auth endpoints return. */
export const AUTH_ERROR = {
  invalidCredentials: 'invalid_credentials',
  resetTokenInvalid: 'reset_token_invalid',
} as const;

/** Password rules shown live on B04. Keys map to `auth.reset.rules.*`. */
export type PasswordRuleKey = 'length' | 'case' | 'number' | 'symbol' | 'match';

export interface PasswordRule {
  key: PasswordRuleKey;
  met: boolean;
}

export function checkPasswordRules(password: string, confirm: string): PasswordRule[] {
  return [
    { key: 'length', met: PASSWORD_PARTS.length(password) },
    { key: 'case', met: PASSWORD_PARTS.lower(password) && PASSWORD_PARTS.upper(password) },
    { key: 'number', met: PASSWORD_PARTS.number(password) },
    { key: 'symbol', met: PASSWORD_PARTS.symbol(password) },
    { key: 'match', met: password.length > 0 && password === confirm },
  ];
}
